import { useCallback } from 'react';
import { useSearchStore } from '../stores/search-store.js';
import { useSearch } from './useSearch.js';

/**
 * Hook for advanced panel fields: closes the panel and triggers search.
 * Call on Enter keypress in any advanced panel input.
 */
export function useAdvancedSubmit() {
  const setAdvancedOpen = useSearchStore((s) => s.setAdvancedOpen);
  const { execute } = useSearch();

  const submit = useCallback(() => {
    setAdvancedOpen(false);
    void execute(1);
  }, [setAdvancedOpen, execute]);

  return { submit };
}
